export default "__VITE_ASSET__DWKEM3Jy__"